<template>
  <li class="comment moderated">

      <div class="moderated-header">
        <i class="moderated-icon fal fa-exclamation-triangle"></i>
        <p class="moderated-text">Comentario moderado por valoración negativa</p>
        <div class="moderated-toggle" @click="showComment = !showComment">
          <p v-if="!showComment">Mostrar</p>
          <p v-else>Ocultar</p>
          <i class="far fa-chevron-down" v-if="!showComment"></i>
          <i class="far fa-chevron-up"  v-else></i>
        </div>
      </div>

      <transition name="reported-comment">
        <div class="comment" :class="type" v-if="showComment">
          <div class="comment-wrapper">
            <div class="comment-header">
              <edi-user-comment-avatar
                :src="authorAvatarUrl"
                :user-profile-url="userProfileUrl"
              />
              <div class="comment-header-wrapper">
                <edi-user-comment
                  :num="num"
                  :author-name="authorName"
                  :publication-date="publicationDate"
                  :user-profile-url="userProfileUrl"
                />
                <edi-replied-comment-chip v-if="commentIsReply" :comment="repliedComment" />
                <edi-featured-comment-chip v-if="isFeatured" />
              </div>
            </div>
            <div class="comment-text">
              <p class="text">{{ text }}</p>
            </div>
            <edi-comment-actions
              :likes="totalLikes"
              :dislikes="totalDislikes"
              :moderated-votes="moderatedVotes"
              :comment-id="id"
              :content-id="contentId"
              :user-id="userId"
              :user-nick="userNick"
              :is-author="isAuthorComment"
            />
          </div>
        </div>
      </transition>
  </li>
</template>

<script>
  import EdiCommentActions from '../EdiCommentActions';
  import EdiUserCommentAvatar from '../user/EdiUserCommentAvatar';
  import EdiUserComment from '../user/EdiUserComment';
  import EdiFeaturedCommentChip from '../featured/EdiFeaturedCommentChip';
  import EdiCommentValuationBtn from '../btn/EdiCommentValuationBtn';
  import EdiCommentBadger from '../badger/EdiCommentBadger';
  import EdiMutedCommentListItem from '../list-item/EdiMutedCommentListItem';
  import EdiModeratedCommentListItem from '../list-item/EdiModeratedCommentListItem';
  import EdiRepliedCommentChip from '../reply/EdiRepliedCommentChip';

  import { PARTNER_COMMENT, DEFAULT_COMMENT, AUTHOR_COMMENT } from "../../api";

  export default {
    name: 'edi-moderated-comment-list-item',
    components: {
      EdiUserCommentAvatar,
      EdiUserComment,
      EdiFeaturedCommentChip,
      EdiCommentActions,
      EdiCommentValuationBtn,
      EdiCommentBadger,
      EdiMutedCommentListItem,
      EdiModeratedCommentListItem,
      EdiRepliedCommentChip
    },
    props: {
      comment: Object,
      contentId: Number,
    },
    data() {
      return {
        showComment: false
      }
    },
    computed: {
      id() {
        return this.comment?.id;
      },
      num() {
        return this.comment?.threadRelativeCommentId;
      },
      text() {
        return this.comment?.text;
      },
      valuation() {
        return {}
      },
      userNick() {
        return this.comment?.userName;
      },
      userAvatarUrl() {
        const userAvatarUrl = this.comment?.user.avatarUrl;
        return userAvatarUrl ? userAvatarUrl : "/assets/img/default-user-avatar.png";
      },
      partnerAge() {
        return this.comment?.user?.partnerAge;
      },
      moderatedVotes() {
        return this.comment?.numReports;
      },
      isFeatured() {
        return this.comment?.isFeatured;
      },
      publicationDate() {
        // Esta patata la hacemos porque en el showroom el Datetime es serializado
        // a un objeto de js con estas propiedades, sin embargo cuando la respuesta
        // viene del Api dicha propiedad viene serializa como un string directamente
        const publicationDate = this.comment?.publicationDate?.date;
        return publicationDate ? publicationDate : this.comment?.publicationDate;
      },
      replies() {
        return this.comment?.replies;
      },
      type() {
        if (this.isAuthorComment) {
          return AUTHOR_COMMENT;
        }
        if (this.isPartnerComment) {
          return PARTNER_COMMENT;
        }
        return DEFAULT_COMMENT;
      },
      isPartnerComment() {
        return this.comment?.user?.isPartner;
      },
      isAuthorComment() {
        return this.comment?.user?.isAuthor;
      },
      isModeratedComment() {
        return this.comment?.isModerated;
      },
      totalLikes() {
        return this.comment?.numVotesPositive;
      },
      totalDislikes() {
        return this.comment?.numVotesNegative;
      },
      commentIsReply() {
        return !!this.comment?.repliedComment;
      },
      repliedComment() {
        return this.comment?.repliedComment;
      },
      userId() {
        return this.comment?.user?.userId;
      },
      userProfileUrl(){
        return this.comment?.user?.profileUrl;
      }
    }
  }
</script>

<style scoped>
  .reported-comment-enter-active, .reported-comment-leave-active{
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .reported-comment-enter, .reported-comment-leave-to {
    opacity: 0;
  }
</style>
